(function () {
    'use strict';

    angular
        .module('core.helpers')
        .service('FlowConfigurationHelper', FlowConfigurationHelper)

    /** @ngInject */
    function FlowConfigurationHelper(ROUTES, LOCAL_STORAGE_ITEMS) {
        const FlowConfigurationHelper = {
            getFlowOptionsDefaults,
            getFlowOptionsDefaultsGallery
        };

        return FlowConfigurationHelper;

        function getFlowOptionsDefaults() {
            const accessToken = localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);
            const companyId = localStorage.getItem(LOCAL_STORAGE_ITEMS.SELECTED_COMPANY);
            let headers = {};

            if (accessToken) {
                headers['Authorization'] = 'Bearer ' + accessToken;
                headers['company_id'] = companyId;
            }

            return {
                permanentErrors: [500, 501, 428],
                maxChunkRetries: 1,
                chunkRetryInterval: 5000,
                simultaneousUploads: 1,
                allowDuplicateUploads: true,
                singleFile: true,
                target: `${ROUTES.API}/upload/images`,
                headers: headers
            }
        }

        function getFlowOptionsDefaultsGallery() {
            const accessToken = localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN);
            const companyId = localStorage.getItem(LOCAL_STORAGE_ITEMS.SELECTED_COMPANY);
            let headers = {};

            if (accessToken) {
                headers['Authorization'] = 'Bearer ' + accessToken;
                headers['company_id'] = companyId;
            }

            return {
                permanentErrors: [500, 501, 428],
                maxChunkRetries: 1,
                chunkRetryInterval: 5000,
                allowDuplicateUploads: true,
                simultaneousUploads: 5,
                target: `${ROUTES.API}/upload/images`,
                headers: headers
            }
        }
    }
}());